(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ad-cart-note-save"] && !Shopify.designMode) return;
  try {
    (()=>{
  let pending=Promise.resolve();
  let revision=0;
  function saveNote(input){
    const root=input.closest('.cart-note')?.querySelector('.ad-note-save');
    if(!root)return;
    const note=input.value;
    const current=++revision;
    const status=root.querySelector('[data-ad-note-status]');
    const button=root.querySelector('[data-ad-save-note]');
    status.textContent=root.dataset.saving;
    button.disabled=true;
    pending=pending.catch(()=>{}).then(async()=>{
      const response=await fetch(window.routes?.cart_update_url||'/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({note})});
      if(!response.ok)throw new Error('note_save_failed');
      await response.json();
      if(current===revision)status.textContent=root.dataset.saved;
    }).catch(()=>{
      if(current===revision)status.textContent=root.dataset.error;
    }).finally(()=>{
      if(current===revision)button.disabled=false;
    });
  }
  document.addEventListener('change',event=>{if(event.target.matches('#cart-note'))saveNote(event.target);});
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-ad-save-note]');
    if(!button)return;
    const input=button.closest('.cart-note')?.querySelector('#cart-note');
    if(input)saveNote(input);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ad-product-whatsapp"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  const link=event.target.closest('[data-ad-product-whatsapp]');
  if(!link)return;
  const page=new URL(window.location.href);
  const product=new URL(link.dataset.productUrl);
  const variant=page.searchParams.get('variant');
  if(variant)product.searchParams.set('variant',variant);
  const message='Hola, tengo una duda sobre '+link.dataset.productTitle+': '+product.href;
  link.href='https://wa.me/34656933397?text='+encodeURIComponent(message);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["halo-notify-sold-out"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',function(event){
  const form=event.target;
  if(!form.matches('.ad-restock-form'))return;
  const read=name=>form.querySelector('[name="'+name+'"]')?.value||'';
  const body=form.querySelector('[name="contact[body]"]');
  body.value=['Solicitud de aviso de reposición',read('halo-notify-product-title'),read('halo-notify-product-variant'),read('halo-notify-product-link')].join(' — ');
});
  } catch(e) { console.error(e); }
})();

})();
